import {FC} from 'react';
import type {ProfileDocumentItem} from '../../model/profileDocuments';
import {ProfileDocumentIconView} from './ProfileDocumentIcons';
import styles from './ProfileDocumentsList.module.css';

export type ProfileDocumentsListProps = {
	documents: ProfileDocumentItem[];
	onDocumentClick?: (document: ProfileDocumentItem) => void;
};

export const ProfileDocumentsList: FC<ProfileDocumentsListProps> = ({documents, onDocumentClick}) => (
	<ul className={styles.list}>
		{documents.map((document) => {
			const isClickable = Boolean(onDocumentClick);

			return (
				<li key={document.id} className={styles.card}>
					{isClickable ? (
						<button type="button" className={styles.cardButton} onClick={() => onDocumentClick?.(document)}>
							<span className={styles.iconWrap}>
								<ProfileDocumentIconView name={document.icon} className={styles.icon} />
							</span>
							<div className={styles.text}>
								<p className={styles.title}>{document.title}</p>
								<p className={styles.value}>{document.value}</p>
							</div>
						</button>
					) : (
						<>
							<span className={styles.iconWrap}>
								<ProfileDocumentIconView name={document.icon} className={styles.icon} />
							</span>
							<div className={styles.text}>
								<p className={styles.title}>{document.title}</p>
								<p className={styles.value}>{document.value}</p>
							</div>
						</>
					)}
				</li>
			);
		})}
	</ul>
);
